<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-6">
        <vs-button
          type="filled"
          class="float-right"
          id="l-confirm-btn"
          @click.prevent="submitForm"
          v-show="
            (this.model.draftOrder != null || !modify) && onEditDateSettlement
          "
          >{{ $t("CreateDischargePermission") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right mx-4"
          id="submit-btn"
          @click.prevent="showfile()"
          v-if="onEditDateSettlement"
          >{{ $t("Attachments") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right mr-4"
          color="danger"
          @click.prevent="rejectDraftOrder()"
          v-if="onEditDateSettlement"
          >{{ $t("DraftOrderRejected") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right mr-4"
          :color="onEditDateSettlement ? 'purple' : 'danger'"
          @click.prevent="onEditDateSettlement = !onEditDateSettlement"
          >{{
            onEditDateSettlement ? $t("EditDateSettlement") : $t("Cancel")
          }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right mr-4"
          color="success"
          v-if="!onEditDateSettlement"
          @click.prevent="EditedDateSettlement"
          >{{ $t("SubmitDateSettlement") }}</vs-button
        >
        <vs-button
          type="filled"
          class="float-right m-0"
          id="reset-btn"
          @click.prevent="resetForm"
          v-if="onEditDateSettlement"
          >{{ $t("Reset") }}</vs-button
        >
        <vs-button
          type="button"
          class="float-left mx-2"
          style="background-color: #444"
          @click.prevent="backToCurrentGrid()"
          >{{ $t("Back") }}</vs-button
        >
      </div>
    </div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <form>
          <div class="vx-row">
            <div class="vx-col md:w-1/4 w-full">
              <label class="vs-select--label">{{ $t("PartyName") }}</label>
              <vs-input name="partyName" disabled v-model="BusinessPartyName" />
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <label class="vs-select--label">{{ $t("DraftOrderId") }}</label>
              <vs-input
                name="draftOrderId"
                disabled
                v-model="this.draftOrderId"
              />
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <label class="vs-select--label">{{
                $t("TotalAmountOrder")
              }}</label>
              <vs-input
                name="totalAmountForPayment"
                disabled
                v-model="this.allData.totalAmountForPayment"
              />
            </div>
            <div class="vx-col md:w-1/4 w-full">
              <span
                :class="onEditDateSettlement ? '' : 'text-danger'"
                class="vs-select--label"
                >{{ $t("DateSettlement") }}</span
              >
              <vs-input
                name="settlementDate"
                v-if="onEditDateSettlement"
                v-model="this.justDateInSettlementDate"
                disabled
              />
              <date-picker
                v-else
                v-model="newDateInSettlementDate"
                type="datetime"
                format="jYYYY-jMM-jDD HH:mm:ss"
                display-format="jYYYY-jMM-jDD HH:mm:ss"
                class="date-picker"
                :label="$t('Calendar')"
                :clearable="true"
              />
            </div>
          </div>
        </form>
        <div class="vx-row">
          <div class="vx-col w-full mb-2 mt-4">
            <vs-table :data="info" class="custom-tbl">
              <template slot="thead">
                <th style="width: 2%">#</th>
                <th style="width: 19%">{{ $t("ProductName") }}</th>
                <th style="width: 6%">{{ $t("ItemCode") }}</th>
                <th style="width: 8%">{{ $t("Warehouse") }}</th>
                <th style="width: 5%">{{ $t("Shelve") }}</th>
                <th style="width: 5%">{{ $t("DraftOrderCount") }}</th>
                <th style="width: 9%">
                  {{ $t("UnitPrice") }}
                </th>
                <th style="width: 9%">
                  {{ $t("TotalTaxAmount") }}
                </th>
                <th style="width: 9%">
                  {{ $t("Price") }}
                </th>
                <th style="width: 9%">
                  {{ $t("SumOfDiscount") }}
                </th>
                <th style="width: 9%">
                  {{ $t("TotalAmountAfterDeductionOfDiscounts") }}
                </th>
                <th style="width: 5%">{{ $t("Count") }}</th>
                <th style="width: 5%">{{ $t("Action") }}</th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="i" v-for="(index, i) in data">
                  <vs-td>
                    {{ i + 1 }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].name }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].itemCode }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].warehouse }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].shelve }}
                  </vs-td>
                  <vs-td>
                    {{ data[i].draftOrderCount }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].unitPrice).toLocaleString() }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].totalTaxAmount).toLocaleString() }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].price).toLocaleString() }}
                  </vs-td>
                  <vs-td>
                    {{ Number(data[i].sumOfDiscount).toLocaleString() }}
                  </vs-td>
                  <vs-td>
                    {{
                      Number(
                        data[i].totalAmountAfterDeductionOfDiscounts
                      ).toLocaleString()
                    }}
                  </vs-td>
                  <vs-td class="count-input">
                    <vs-input
                      v-model="data[i].count"
                      name="count"
                      v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
                      :class="{ 'is-invalid': errors.has('count') }"
                    />
                  </vs-td>
                  <vs-td>
                    <vs-button
                      radius
                      color="danger"
                      size="small"
                      type="gradient"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.prevent="deletePro(i)"
                      class="d-inline"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
                <vs-tr
                  :style="{
                    background: '#007470 !important',
                    direction: 'ltr',
                  }"
                  class="text-white"
                >
                  <vs-td> جمع </vs-td>
                  <vs-td> </vs-td>
                  <vs-td> </vs-td>
                  <vs-td> </vs-td>
                  <vs-td> </vs-td>
                  <vs-td
                    >{{
                      allData.sumOfDiscounts
                        ? Number(allData.sumOfCount).toLocaleString()
                        : "---"
                    }}
                  </vs-td>
                  <vs-td> </vs-td>
                  <vs-td
                    >{{
                      allData.sumOfDiscounts
                        ? Number(allData.sumOfTotalTax).toLocaleString()
                        : "---"
                    }}
                  </vs-td>
                  <vs-td>
                    {{
                      allData.sumOfDiscounts
                        ? Number(allData.sumOfPrice).toLocaleString()
                        : "---"
                    }}
                  </vs-td>
                  <vs-td
                    >{{
                      allData.sumOfDiscounts
                        ? Number(allData.sumOfDiscounts).toLocaleString()
                        : "---"
                    }}
                  </vs-td>
                  <vs-td
                    >{{
                      allData.sumOfDiscounts
                        ? Number(allData.sumOfTotalAmount).toLocaleString()
                        : "---"
                    }}
                  </vs-td>
                  <vs-td> </vs-td>
                  <vs-td> </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <!-- <div style="background-color: #007470; color: white">
              <div
                style="
                  margin: 0 72% 0 19%;
                  background-color: black;
                  text-align: center;
                  font-size: 1rem;
                "
              >
                {{
                  allData.sumOfDiscounts
                    ? Number(allData.sumOfDiscounts).toLocaleString()
                    : "---"
                }}
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <files-and-attachments-popup
      :show="isShowFile"
      @finish="onfinish"
      :basketId="basketId"
      :totalPrice="totalPrice"
      :date="justDateInSettlementDate?justDateInSettlementDate:''"
    ></files-and-attachments-popup>
    <!-- <div class="vx-card mt-4" v-if="showFiles">
      <div class="vx-card__body card-body">
        <files-and-attachments :basketId="basketId"></files-and-attachments>
      </div>
    </div> -->
  </div>
</template>
<style lang="scss">
#reset-btn {
  background: #3ec9d6 !important;
}
.vue-treeselect--disabled .vue-treeselect__control {
  padding: 0.19rem 0.7rem !important;
}
.vue-treeselect--disabled
  .vue-treeselect__control
  .vue-treeselect__value-container {
  top: 1px;
}
#submit-btn {
  margin-right: 2rem;
}
#add-order .is-invalid input {
  border-color: red !important;
}
.count-input input {
  text-align: center !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import vSelect from "vue-select";
import FilesAndAttachments from "./FilesAndAttachments.vue";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import FilesAndAttachmentsPopup from "./FilesAndAttachmentsPopup.vue";

export default {
  name: "warehouseManagement_DischargePermission_Create",
  components: {
    "v-select": vSelect,
    FilesAndAttachments,
    FilesAndAttachmentsPopup,
    datePicker: VuePersianDatetimePicker,
  },
  data() {
    return {
      customerIsBtoC: this.$route.query.customerIsBtoC,
      onEditDateSettlement: true,
      BusinessPartyName: "",
      DateSettlement: "",
      draftOrderId: "",
      totalAmountForPayment: "",
      justDateInSettlementDate: "",
      newDateInSettlementDate: "",
      showFiles: false,
      model: {
        draftOrder: null,
      },
      modelEditSettlementDate: {},
      modelReject: {
        basketId: "",
        reasonOfReject: "",
      },
      info: [],
      isShowFile: false,
      totalPrice:'',
      allData: "",
      basketId: "",
      disabled: false,
      dischargePermissionModel: {
        draftOrderId: null,
        dischargePermissionItemCommands: [
          {
            storeId: null,
            shelveId: null,
            productId: null,
            count: null,
          },
        ],
      },
      modify: true,
      url: "Baskets/Avasys_c1f3e92e135f4ad18539d45fdd60e881_Baskets.vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    };
  },
  computed: {
    ...mapGetters({
      agentCredit: "sale/agentCreditDetails",
      sockDraftOrderDetails: "draftOrder/sockDraftOrderDetails",
    }),
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      rejectBasket: "basket/rejectBasket",
      updateSettlementDate: "basket/updateSettlementDate",
      sockDraftOrdersQuerySearch: "draftOrder/sockDraftOrdersQuerySearch",
      fetchStockDraftOrderDetails: "draftOrder/sockDraftOrder",
      createDischargePermission:
        "dischargePermissions/createSaleAgentDischargePermission",
    }),
    showfile() {
      this.totalPrice = this.allData.totalAmountForPayment;
      this.date=this.justDateInSettlementDate;
      this.isShowFile = true;
    },
    onfinish() {
      this.isShowFile = false;
      this.isShowDescriptionPopup = false;
    },
    load() {
      if (this.$route.query.DraftOrderId) {
        this.modify = false;
        this.draftOrderId = this.$route.query.DraftOrderId;
        this.dischargePermissionModel.draftOrderId = this.draftOrderId;
        this.fetchStockDraftOrderDetails(this.draftOrderId).then((r) => {
          this.allData = r;
          this.totalAmountForPayment = this.allData.totalAmountForPayment;
          this.justDateInSettlementDate = this.allData.settlementDate;
          this.basketId = this.allData.basketId;
          this.createProductModel();
          this.BusinessPartyName =
            this.sockDraftOrderDetails.stockDraftOrderPartyInfoQuery.name;
        });
      }
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/DischargePermissions/Index",
        query: {
          referencePageInfo: {
            tabIndex: 0,
            numberRowsPerPage: this.$route.query.numberRowsPerPage,
          },
        },
      });
    },
    showAttachments() {
      this.showFiles = !this.showFiles;
    },
    onDraftOrderSelected(data) {
      this.fetchStockDraftOrderDetails(data.id).then(() => {
        this.createProductModel();
      });
      this.dischargePermissionModel.draftOrderId = data.id;
    },
    EditedDateSettlement() {
      this.modelEditSettlementDate.settlementDate =
        this.newDateInSettlementDate;
      this.modelEditSettlementDate.basketId = this.basketId;
      this.updateSettlementDate(this.modelEditSettlementDate).then(() => {
        setTimeout(() => {
          this.load();
        }, 3000);
        this.onEditDateSettlement = !this.onEditDateSettlement;
      });
    },
    createProductModel() {
      var array = this.info;
      this.sockDraftOrderDetails.stockDraftOrderItemsQueryDto.forEach(
        (element) =>
          array.push({
            name: element.stockDraftOrderProductInfoQuery.productName,
            productId: element.stockDraftOrderProductInfoQuery.productId,
            itemCode: element.stockDraftOrderProductInfoQuery.itemCode,
            draftOrderCount: element.count,
            warehouse: element.stockDraftOrderShelveInfoQuery.storeName,
            shelve: element.stockDraftOrderShelveInfoQuery.shelveName,
            shelveId: element.stockDraftOrderShelveInfoQuery.shelveId,
            storeId: element.stockDraftOrderShelveInfoQuery.storeId,
            countOfDischargePermissionRegistered:
              element.countOfDischargePermissionRegistered,
            count: element.remainingCount,
            totalAmount: element.totalAmount,
            price: element.price,
            sumOfDiscount: element.sumOfDiscount,
            unitPrice: element.unitPrice,
            unitTotalTax: element.unitTotalTax,
            totalTaxAmount: element.totalTaxAmount,
            contractPrice: element.contractPrice,
            totalAmountAfterDeductionOfDiscounts:
              element.totalAmountAfterDeductionOfDiscounts,
          })
      );
    },
    deletePro(item) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.info.splice(item, 1),
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
        }
      });
    },
    submitForm() {
      this.dischargePermissionModel.dischargePermissionItemCommands = this.info;
      this.disabled = true;
      this.createDischargePermission(this.dischargePermissionModel).then(() => {
        setTimeout(() => {
          this.$router.push({
            path: "/DischargePermissions/Index",
            query: {
              referencePageInfo: {
                tabIndex: 0,
                numberRowsPerPage: this.$route.query.numberRowsPerPage,
              },
            },
          });
        }, 3000);
      });
      this.disabled = false;
    },
    rejectDraftOrder() {
      (async () => {
        const { value: reasonOfReject } = await this.$swal({
          input: "textarea",
          inputLabel: "Message",
          title: "آیا از رد این پیش فاکتور اطمینان دارید؟",
          inputPlaceholder: "علت رد پیش فاکتور...",
          inputAttributes: {
            required: true,
          },
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "ثبت",
          cancelButtonText: "بستن",
        });
        if (reasonOfReject) {
          var basketId = this.basketId;
          this.rejectBasket({ reasonOfReject, basketId }).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "پیش فاکتور مورد‌نظر با موفقیت رد شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.backToCurrentGrid();
          });
        }
      })();
    },
    resetForm() {
      this.$router.go(this.$router.currentRoute);
    },
  },
  watch: {
    totalAmountForPayment(value) {
      if (value) {
        var m = Number(value);
        this.allData.totalAmountForPayment = m.toLocaleString();
      } else {
        this.totalAmountForPayment = 0;
        this.allData.totalAmountForPayment = 0;
      }
    },
    justDateInSettlementDate(value) {
      if (value) {
        this.justDateInSettlementDate =
          this.allData.settlementDate.split(" ")[1];
      }
    },
  },
};
</script>
